module.exports = __webpack_public_path__ + "static/img/img4.623f7ebd.png";